module.exports = __webpack_public_path__ + "img/filter.9ed625796502d290b188efb941eb80b9.svg";